export default __webpack_public_path__ + "static/media/google-play-badge.8402d4a5.png";